import { useEffect } from "react";
import {
  MOVIES_LIST,
  NOW_PLAYING,
  POPULAR,
  TMDB_API_OPTION,
  TOP_RATED,
  UPCOMING,
  getMoviesListURL,
} from "../utils/constants";
import { useDispatch } from "react-redux";
import {
  addNowPlayingMovies,
  setPopularMovies,
  setTopRatedMovies,
  setUpcomingMovies,
} from "../store/movieSlice";

export const useGetMoviesList = () => {
  const dispatch = useDispatch();
  // function to fetch now playing movies
  const getMoviesList = async ({ listname, language, region }) => {
    const data = await fetch(
      getMoviesListURL(listname, language, region),
      TMDB_API_OPTION
    );
    const movies = await data.json();
    switch (listname) {
      case NOW_PLAYING:
        dispatch(addNowPlayingMovies(movies?.results));
        break;
      case POPULAR:
        dispatch(setPopularMovies(movies?.results));
        break;
      case TOP_RATED:
        dispatch(setTopRatedMovies(movies?.results));
        break;
      case UPCOMING:
        dispatch(setUpcomingMovies(movies?.results));
        break;
    }
  };

  useEffect(() => {
    MOVIES_LIST.map((name) => {
      const movieList = { listname: name, language: "en-US", region: "US" };
      getMoviesList(movieList);
    });
  }, []);
};
